// 绑定的优先级及兜底规则，不因启用状态豁免（D122、D132）。账号绑定按列表顺序生成优先级，只复用 unconditionalRule（#363）。
import type { RouteConditions } from "@/app/routing";

/** 空数组或null均表示不限。 */
export function unconditionalRule(m: RouteConditions): boolean {
  return !m.mcc && !m.mnc && !m.senders?.length;
}

/** 模板成员手填的优先级校验：不舍入有符号整数，只在本模板范围比较（D132）。 */
export function routingOrderError(items: { priority: string; match: RouteConditions }[]): string | undefined {
  const priorities = new Set<number>();
  for (let i = 0; i < items.length; i++) {
    const priority = Number(items[i].priority);
    if (!/^-?\d+$/.test(items[i].priority.trim()) || !Number.isSafeInteger(priority)) return `第 ${i + 1} 条优先级须为可精确表示的整数。`;
    if (priorities.has(priority)) return "优先级不能重复。";
    priorities.add(priority);
  }
  const maximum = items.reduce((n, b) => Math.max(n, Number(b.priority)), -Infinity);
  if (items.some(b => Number(b.priority) !== maximum && unconditionalRule(b.match))) return "无条件兜底只能是最后一条，请调整优先级。";
}
